import React, { useRef, useState } from 'react';
import { Container, Row, Col, Form, Button, Modal } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import emailjs from 'emailjs-com';
import { Helmet } from 'react-helmet';
import './NavBarContactUs.css';
import company from '../images/contact1.jpg';
import company1 from '../images/contact2.jpg';

const NavBarContactUs = () => {
  const [showModal, setShowModal] = useState(false);

  const formRef1 = useRef();
  const formRef2 = useRef();

  const handleCloseModal = () => setShowModal(false);

  const sendEmail = (e, formRef) => {
    e.preventDefault();

    const formData = new FormData(formRef.current);
    let valid = true;

    formData.forEach((value, key) => {
      if (!value.trim()) valid = false;
      else formData.set(key, value.trim());
    });

    const phone = formData.get('phone');
    const message = formData.get('message');

    if (!/^\d{10}$/.test(phone)) {
      alert("Phone number must be exactly 10 digits.");
      return;
    }

    if (message.split(' ').filter(word => word).length < 10) {
      alert("Message must contain at least 10 words.");
      return;
    }

    if (!valid) {
      alert("All fields are required.");
      return;
    }

    emailjs.sendForm(
      'service_6h8qv4y',
      'template_c0kjsge',
      formRef.current,
      'TOmO43hNY3cMn1drt'
    ).then(() => {
      setShowModal(true);
      formRef.current.reset();
    }).catch((error) => {
      console.error('Error:', error.text);
    });
  };

  return (
    <Container className="contact-us">

      {/* 🔥 SEO META */}
      <Helmet>
        <title>Contact Plastic Safety Eyes Manufacturer | Bulk Orders India</title>
        <meta 
          name="description" 
          content="Contact Pushkar Enterprises for bulk orders of plastic safety eyes, soft toy eyes, and toy accessories. Manufacturer based in Delhi, India." 
        />
      </Helmet>

      {/* 🔥 FIRST FORM */}
      <Row className="form-row mb-5">
        <Col md={6} className="form-col">

          <h1 className="form-heading">
            Bulk Inquiry for Plastic Safety Eyes
          </h1>

          <p>
            Contact us for <strong>bulk orders of plastic safety eyes, soft toy eyes, and toy noses</strong>. 
            We supply manufacturers, exporters, and wholesalers across India.
          </p>

          <Form ref={formRef1} onSubmit={(e) => sendEmail(e, formRef1)}>
            <Form.Control type="text" name="from_name" placeholder="Name" required />
            <Form.Control type="text" name="organization_name" placeholder="Company Name" required />
            <Form.Control type="text" name="subject" placeholder="Subject (Bulk Order / Inquiry)" required />
            <Form.Control type="email" name="reply_to" placeholder="Email" required />
            <Form.Control type="tel" name="phone" placeholder="Phone" required />
            <Form.Control as="textarea" name="message" rows={3} placeholder="Your requirement (quantity, size, type...)" required />

            <Button variant="dark" type="submit" className="submit-button">
              Request Bulk Quote
            </Button>
          </Form>
        </Col>

        <Col md={6} className="image-col">
          <img 
            src={company1} 
            alt="plastic safety eyes manufacturing unit India" 
            className="info-image" 
          />
        </Col>
      </Row>

      {/* 🔥 SECOND FORM */}
      <Row className="form-row mb-5">
        <Col md={6} className="form-col">

          <h2 className="form-heading">Become a Supplier / Vendor</h2>

          <p>
            Partner with us for supplying raw materials or services related to 
            <strong> soft toy accessories manufacturing</strong>.
          </p>

          <Form ref={formRef2} onSubmit={(e) => sendEmail(e, formRef2)}>
            <Form.Control type="text" name="from_name" placeholder="Name" required />
            <Form.Control type="email" name="reply_to" placeholder="Email" required />
            <Form.Control type="text" name="subject" placeholder="Subject" required />
            <Form.Control type="tel" name="phone" placeholder="Phone" required />
            <Form.Control as="textarea" name="message" rows={3} placeholder="Your proposal..." required />

            <Button variant="dark" type="submit" className="submit-button">
              Submit Proposal
            </Button>
          </Form>
        </Col>

        <Col md={6} className="image-col">
          <img 
            src={company} 
            alt="soft toy accessories manufacturing India factory" 
            className="info-image" 
          />
        </Col>
      </Row>

      {/* MODAL */}
      <Modal show={showModal} onHide={handleCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>Request Sent</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Thank you! Your inquiry has been received. Our team will contact you shortly.
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

    </Container>
  );
};

export default NavBarContactUs;